import { MTemplateDataFileResource } from './MTemplateDataFileResource';

export class MTemplateDataFileListResource {
	mTemplateDataFileList: MTemplateDataFileResource[];
}